import { Stack, Typography } from "@mui/material";
import { ActivePosition } from "src/types/products";

import IconType from "./IconType";

export default function PositionName({ name, assetType }: ActivePosition) {
	return (
		<Stack alignItems='center' direction='row' gap={2} width={220}>
			<IconType type={assetType} size={15} />
			<Typography variant='subtitle1' fontSize={13}>
				{name}
			</Typography>
		</Stack>
	);
}
